import { useMemo } from 'react';
import { Badge } from 'reactstrap';
import { TeacherFileItemStatus } from '../enums/teacher-file-item-status.enum';

interface BadgeStateProps {
  status: TeacherFileItemStatus;
  text: string;
}
export default function BadgeState({ status, text }: BadgeStateProps) {
  const colors = useMemo(() => {
    return {
      [TeacherFileItemStatus.Uncompleted]: '#FFE6A1',
      [TeacherFileItemStatus.Completed]: '#CEF0DA',
    };
  }, []);

  return (
    <>
      <div className="d-flex align-items-center justify-content-center student-degree-status-badge">
        <Badge
          className="status-badge fs-16 fw-400 py-2 px-4 text-dark"
          style={{ backgroundColor: colors[status], width: '110px' }}
          pill
        >
          {text}
        </Badge>
      </div>
    </>
  );
}
